import {TFunction} from 'react-i18next';
import Excel from 'exceljs';
import i18n from 'i18n/i18n';
import {
	createZIPXL,
	renderHeaderXL,
} from 'components/InfinityList/Excel/ExcelExportCommon';
import {
	buildVexClusterDescriptionRows,
	buildVkoVexRow,
	VkoVexExportItem,
} from 'components/EntityList/Excel/vkoVexExportRows';

interface IVkoVexPage {
	(entityListItems: any[], t: TFunction): Promise<void>;
}

export const handleClickVkoVexPage: IVkoVexPage = async (
	entityListItems,
	t,
) => {
	const strTrNS = 'features/adminsection';
	const strTrPrefix = 'AdminKeywordsPage';
	const strPageName = t('VkoVexList', {
		ns: 'features/adminsection',
		keyPrefix: 'AdminVexClustersPage',
	});
	const arrColWidth = [30, 40, 30, 30, 30, 20, 30, 20, 20, 20];
	const workbook = new Excel.Workbook();
	const sheet = workbook.addWorksheet('TRACE_VKO-VEX');
	renderHeaderXL(workbook, sheet, arrColWidth, strPageName, t);

	let intRowCount = 4;
	let row = sheet.getRow(intRowCount);
	row.font = {
		bold: true,
		name: 'Porsche Next TT',
		size: 10,
		color: {argb: 'FFFFFFFF'},
	};
	sheet.addTable({
		name: 'tableVKOVEX',
		ref: 'B' + String(intRowCount),
		style: {
			showRowStripes: true,
		},
		columns: [
			{
				name: t('Keywords', {ns: strTrNS, keyPrefix: strTrPrefix}),
				filterButton: true,
			},
			{
				name: t('Description', {ns: strTrNS, keyPrefix: strTrPrefix}),
				filterButton: true,
			},
			{
				name: t('RegulationClusters', {ns: strTrNS, keyPrefix: strTrPrefix}),
				filterButton: true,
			},
			{
				name: t('Vkos', {ns: strTrNS, keyPrefix: strTrPrefix}),
				filterButton: true,
			},
			{
				name: t('VexClusters', {ns: strTrNS, keyPrefix: strTrPrefix}),
				filterButton: true,
			},
			{
				name: t('Vex', {ns: strTrNS, keyPrefix: strTrPrefix}),
				filterButton: true,
			},
			{
				name: t('VexClusterApprovers', {ns: strTrNS, keyPrefix: strTrPrefix}),
				filterButton: true,
			},
		],
		rows: [],
	});

	intRowCount++;
	const table = sheet.getTable('tableVKOVEX');
	for (let ii = 0; ii < entityListItems.length; ii++) {
		row = sheet.getRow(intRowCount);
		row.alignment = {wrapText: true, vertical: 'top'};
		table.addRow(
			buildVkoVexRow(entityListItems[ii] as VkoVexExportItem, i18n.language),
		);

		intRowCount++;
	}

	table.commit();
	const clusterSheet = workbook.addWorksheet(
		t('VexClusterDescriptions', {ns: strTrNS, keyPrefix: strTrPrefix}),
	);
	clusterSheet.columns = [{width: 40}, {width: 80}];
	clusterSheet.views = [{state: 'frozen', ySplit: 1}];
	clusterSheet.addTable({
		name: 'tableVexClusterDescriptions',
		ref: 'A1',
		style: {showRowStripes: true},
		columns: [
			{
				name: t('VexClusters', {ns: strTrNS, keyPrefix: strTrPrefix}),
				filterButton: true,
			},
			{
				name: t('VexClusterDescription', {ns: strTrNS, keyPrefix: strTrPrefix}),
				filterButton: true,
			},
		],
		rows: buildVexClusterDescriptionRows(entityListItems, i18n.language),
	});
	clusterSheet.eachRow(row => {
		row.alignment = {wrapText: true, vertical: 'top'};
	});
	const strZipName = 'VKO-VEX';
	await createZIPXL(workbook, strZipName, t);
};
